import FontAwesomeIconContainer from "../../components/icon/fontAwesomeIcon";

const FontAwesome = () => {
  return <FontAwesomeIconContainer />;
};

export default FontAwesome;
